import React from 'react';
import Home from './Home';
import Layout from '../../components/Layout';
import { getCategory } from '../../actions/category/getCategory';
async function action({ client, store }) {
  const title = store?.getState()?.siteSettings?.data?.siteTitle
  const description = store?.getState()?.siteSettings?.data?.metaDescription;
  const categories = store?.getState()?.categories?.data;

  !categories && store.dispatch(getCategory());

  return {
    title,
    description,
    component: (
      <Layout>
        <Home />
      </Layout>
    ),
  };
}

export default action;
